import "./Profile.css";

export default function Profile({ user, onLogout }) {
  const displayName = user || "Member";

  return (
    <main className="profile-page">
      <p className="profile-eyebrow">ACCOUNT</p>
      <h1>Your profile</h1>
      <p className="profile-intro">Your Yants workspace account.</p>
      <section aria-label="Account details" className="profile-details">
        <span className="profile-large-avatar">{displayName.slice(0, 2).toUpperCase()}</span>
        <div>
          <h2>{displayName}</h2>
          <p>Workspace member</p>
        </div>
      </section>
      <button className="profile-signout" onClick={onLogout} type="button">Log out</button>
    </main>
  );
}
